<main class="main-wrap">
    <app-transaction-component *ngIf="success"></app-transaction-component>
    <app-transaction-fail-component *ngIf="fail"></app-transaction-fail-component>
    <app-transaction-pending-component *ngIf="waitingValidation"></app-transaction-pending-component>
</main>
